import { Result, Button } from 'antd';
import React from 'react';

const API_BASE_URL =
  typeof REACT_APP_ENV !== 'undefined' && REACT_APP_ENV === 'production'
    ? 'https://bps.aigcempower.com'
    : 'https://bps.test.aigcempower.com';

const ForbiddenPage: React.FC = () => {
  const handleBackHome = () => {
    // 跳转到单点登录页
    const redirectUri = `${API_BASE_URL}/welcome`;
    window.location.href = `https://acz.aigcempower.com/login?redirect_uri=${redirectUri}`;
  };

  return (
    <Result
      status="403"
      title="403"
      subTitle="抱歉，您没有权限访问当前页面。"
      extra={
        <Button type="primary" onClick={handleBackHome}>
          返回登录页
        </Button>
      }
    />
  );
};

export default ForbiddenPage;
